import { getRequest } from './util';

const get = async (stationId): Promise<void> =>
  await getRequest(`/stations/${stationId}/returnAliasGroups/options`);

export default {
  get,
};
